<template>
  <div class="card shadow">
    <div class="card-header border-0 dark">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0 sub_title">
            Lista de usuarios
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="primary btn_create" @click="ShowModal">
            Crear Usuario
          </base-button>
          <CreateUser/>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <div class="custom-radio custom-control-inline radio-default-acre"
               v-for="filter in filters"
               :key="filter.id">
            <PrettyRadio
                :id="filter.name"
                :name="filter.name"
                :value="filter.value"
                v-model="filter_seleted">{{ filter.name }}
            </PrettyRadio>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive table-flush mt-3">
      <base-table class="table align-items-center"
                  thead-classes="table-light"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th>Nombre</th>
          <th>Apellido</th>
          <th>Telefono</th>
          <th>Email</th>
          <th>Tipo Usuario</th>
          <th>Tipo Cliente</th>
          <th>Estado</th>
          <th colspan="2"></th>
        </template>
        <template slot-scope="{row}" v-if="row.deletedAt === null">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{ row.name }}</span>
              </div>
            </div>
          </th>
          <td class="budget">
            {{ row.last_name }}
          </td>
          <td class="budget">
            {{ row.phone }}
          </td>
          <td class="budget">
            {{ row.email }}
          </td>
          <td class="budget">
            <div v-for="(item,index) in row.user_type_id" :key="item.id" v-show="index ==='user_type_name'">
              {{ item }}
            </div>
          </td>
          <td class="budget">
            <div v-for="(item,index) in row.client_type_id" :key="item.id"
                 v-show="index ==='client_type_name'">
              {{ item }}
            </div>
          </td>
          <td class="budget">
                        <span v-if="row.user_status == 1">
                            Activo
                        </span>
            <span v-else>
                            Desactivado
                        </span>
          </td>
          <td>
            <div class="btn_icon_edit" @click="EditUser(row.user_id)"></div>

          </td>
          <td>
            <div class="btn_icon_delete" @click="DeleteUser(row.user_id)"></div>
          </td>
        </template>
      </base-table>
    </div>
    <div class="card-footer">
      <base-pagination align="center" v-model="value" :page-count="page_count"></base-pagination>
    </div>

  </div>


</template>
<script>
import _ from 'lodash'
import {bus} from './bus-user'
import {user_service} from '../../services/user/UserService'
import swal from "sweetalert";
import CreateUser from "@/components/User/CreateUser";
import PrettyRadio from 'pretty-checkbox-vue/radio';

export default {
  name: 'ShowUser',
  components: {CreateUser, PrettyRadio},
  data() {
    return {
      tableData: [],
      page_count: 0,
      value: 1,
      filter_seleted: 3,
      filters: [{name: 'Todos', value: 3}, {name: 'Activos', value: 1}, {name: 'Desactivados', value: 0}]
    }
  },
  watch: {
    'value': function () {
      user_service.GetAllUserPagination((this.value * 10) - 10, this.filter_seleted)
    },
    'filter_seleted': function () {
      user_service.GetAllUsers(this.filter_seleted)
    }
  },
  methods: {
    getdata() {
      user_service.GetAllUsers(this.filter_seleted)
      user_service.GetAllRestaurant()
      user_service.GetUserType()
      user_service.GettypeClient()
      user_service.GetAllDiscounts()
      user_service.GetAllDealer()
    },
    ShowModal() {
      bus.Show_Modal();
    },
    EditUser(user_id) {
      const u = _.find(this.tableData, function (item) {
        return item.user_id === user_id
      })
      bus.GetEditUser(u)
    },
    DeleteUser(user_id) {
      var f = new Date()
      let day = f.getDate()
      let month = f.getMonth() + 1
      let year = f.getFullYear()
      let fecha = ''
      if (month < 10) {

        fecha = `${year}/0${month}/${day}`
      } else {
        fecha = `${year}/${month}/${day}`

      }
      const data = {
        user_id: user_id,
        deletedAt: fecha
      }
      swal("¿Seguro que desea eliminar el usuario?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {
              case "Aceptar":
                user_service.DeleteUser(data)
                break;
            }
          });
    }

  },
  created() {
    this.getdata()
    bus.$on('Getdata', () => {
      this.getdata()
    })
    bus.$on('AllUser', (users, value) => {
      this.tableData = users
      this.page_count = Math.ceil(value / 10)
      this.value = 1
    })
    bus.$on('GetAllUserPagination', (users) => {
      this.tableData = users
    })
    bus.$on('DeleteUser', (response) => {
      if (response.data) {
        swal({
          dangerMode: true,
          icon: "success",
          text: "Se Elimino Correctamente.",
          button: "Aceptar"
        })
      } else {
        swal({
          dangerMode: true,
          icon: "error",
          text: "¡No Se Elimino! Intenta de nuevo.",
          button: "Aceptar"
        })
      }
      this.getdata()
    })
  }
}
</script>
<style>
</style>
